import { render, staticRenderFns } from "./AliveGame.vue?vue&type=template&id=220c57c1&scoped=true&"
import script from "./AliveGame.vue?vue&type=script&lang=js&"
export * from "./AliveGame.vue?vue&type=script&lang=js&"
import style0 from "./AliveGame.vue?vue&type=style&index=0&id=220c57c1&prod&lang=css&"
import style1 from "./AliveGame.vue?vue&type=style&index=1&id=220c57c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c57c1",
  null
  
)

export default component.exports